export const locale = {
  lang: "fr",
  data: {
    USER_INFORMATION: {
      TITLE: "Informations utilisateur",
      NAME: "Nom",
      MAIL: "E-mail",
      PHONE: "Téléphone",
      COMPANY: "Entreprise",
      JOB: "Poste",
      REFERENTIEL: "Référentiel de sécurité",
      UNDEFINED_FIELD_M: "Non renseigné",
      UNDEFINED_FIELD_F: "Non renseignée",
      EDIT_BUTTON: "Modifier mes informations",
      MODAL: {
        TITLE: "Modifier les informations de l'utilisateur",
        FIRST_NAME: "Prénom",
        LAST_NAME: "Nom",
        DEFAULT_NAME: "Jean Dupont",
        DEFAULT_MAIL: "jean.dupont@mail.com",
        DEFAULT_PHONE: "(+33)",
        DEFAULT_COMPANY: "IT Support",
        DEFAULT_JOB: "Informaticien",
        DEFAULT_REFERENTIEL: "ANSSI",
        CANCEL_BUTTON: "Annuler",
        EDIT_BUTTON: "Modifier les informations",
        ERROR: 'Ce champs est invalide',
        REFERENTIELS: {
          ANSSI: "ANSSI",
          ISO_27001: "ISO 27001",
          CMMC: "CMMC",
          AIRCYBER: "AirCyber",
          PCI_DSS: "PCI-DSS",
          PGSSI_S: "PGSSI-S",
        },
      },
    },
    SOCIETY_INFORMATION: {
      TITLE: 'Modifier les données de votre société',
      // COUNTRY: 'Pays',
      SOCIETY: 'Nom de la société',
      STREET: 'Adresse',
      STREET2: 'Complément d\'adresse',
      ZIPCODE: 'Code postal',
      CITY: 'Ville',
      // DEFAULT_COUNTRY: '',
      DEFAULT_SOCIETY: '',
      DEFAULT_STREET: '',
      DEFAULT_STREET2: '',
      DEFAULT_ZIPCODE: '',
      DEFAULT_CITY: '',
      ERROR: 'Ce champs est invalide',
      CANCEL_BUTTON: 'Annuler',
      EDIT_BUTTON: 'Enregistrer'
    },
    PLAN: {
      BADGE: {
        BASIC: "Standard",
      },
      DAYS: "Jours",
      MONTH: "mois",
      DAYS_LEFT: "jours restants",
      USERS: "Utilisateurs",
      STORAGE: "Jusqu'à 10 GB de stockage",
      SUPPORT: "Support de base",
      UPGRADE_PLAN: "Améliorer mon abonnement",
      MODAL: {
        TITLE: 'Formules',
      }
    },
    GENERAL: {
      TITLE: "Société",
      CURRENT_PLAN: {
        TITLE: "Plan actuel",
        PLAN: {
          TEXT: "Votre plan actuel est le plan gratuit",
          SUBTEXT: "Un début simple accessible à tous",
        },
        EXPIRATION: {
          TEXT: "Actif jusqu'au",
          SUBTEXT:
            "Nous vous enverrons une notification quand votre abonnement arrivera à expiration",
        },
        PRICE: {
          BADGE: "Populaire",
          TEXT: "99€ par mois",
          SUBTEXT:
            "Le plan Standard est adapté aux petites et moyennes entreprises",
        },
        WARNING: {
          TITLE: "Attention!",
          TEXT: "Votre plan a besoin d'une mise à jour",
        },
        PROGRESS: {
          DAYS: "Jours",
          REQUIRES_UPDATE: "Votre plan a besoin d'une mise à jour",
        },
        UPGRADE_BUTTON: "Mettre à jour mon plan",
        CANCEL_BUTTON: "Annuler mon abonnement",
      },
      PAYMENT_METHODS: {
        TITLE: "Moyen de paiement",
        BUTTON: "Ajouter une carte",
        NO_CARDS: "Vous n'avez enregistré aucune carte.",
        CARDS: {
          BADGES: {
            PRIMARY: "Principale",
            EXPIRED: "Expirée",
          },
          EDIT_BUTTON: "Modifier",
          DELETE_BUTTON: "Supprimer",
          EXPIRES_AT: "Cette carte expire le",
        },
      },
      BILLING_ADDRESS: {
        TITLE: "Informations société",
        BUTTON: "Modifier",
        COMPANY: "Société",
        BILLING_EMAIL: "E-mail de facturation",
        TAX_ID: "NIF",
        VAT_NUMBER: "Numéro de TVA",
        BILLING_ADDRESS: "Adresse",
        CONTACT: "Téléphone",
        COUNTRY: "Pays",
        STATE: "Région",
        ZIP_CODE: "Code postal",
      },
    },
    SECURITY: {
      TITLE: "Sécurité",
      EDIT_PASSWORD: {
        TITLE: "Modifier le mot de passe",
        NEW_PASSWORD: "Nouveau mot de passe",
        CONFIRM_PASSWORD: "Confirmer le nouveau mot de passe",
        EDIT_BUTTON: "Modifier le mot de passe",
        ERRORS: {
          NO_VALID: "Un des champs n'est pas valide.",
          NO_MATCH: "Les mots de passes ne correspondent pas",
          MIN_STRING: "Votre nouveau mot de passe doit faire plus de 6 caractères de long."
        }
      },
      TWO_STEPS_AUTH: {
        TITLE: "Authentification à deux facteurs",
        PROTECT: "Protégez votre compte grâce à l'étape d'authentification.",
        EXPLAIN:
          "L'authentification à deux facteurs ajoute une couche supplémentaire de sécurité à votre compte en exigeant plus qu'un simple mot de passe pour vous connecter.",
      },
      RECENT_DEVICES: {
        TITLE: "Appareils récents",
        NO_LAST_CONNECTION: "Pas de connexion récente.",
        TABLE: {
          HEADERS: {
            BROWSER: "Navigateur",
            DEVICE: "Appareil",
            LOCATION: "Localisation",
            RECENT_ACTIVITY: "Activité récente",
          },
          ROWS: {
            TERM_ON: "sur"
          },
        },
      },
    },
  },
};
